import { GradientTexture, Text, useFont, useScroll } from "@react-three/drei"
import BloodcellIsland from "../../components/models/bloodcell/island.jsx"
import { Suspense, useEffect, useRef } from "react"
import { useFrame, useThree } from "@react-three/fiber"
import gsap from "gsap"

import { mainStore } from "../../store.js"
import { __, ____ } from "../../utils.js"
import Microscope from "../../components/models/microscope/model.jsx"

import Team from "../../components/team.jsx"
import Garage from "../../components/image/Garage.jsx"
import JeanPaufique from "../../components/image/JeanPaufique.jsx"

import TextRight from "../../components/textRight.jsx"
import TextLeft from "../../components/textLeft.jsx"


export default function BodyChapterOne() {

    // Utils
    const { width, height } = useThree((state) => state.viewport)
    const data = useScroll()
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)


    // Store
    const scrollMap = mainStore.useStore((s) => s.scrollMap)
    const preventChapterUpdate = mainStore.useStore((s) => s.preventChapterUpdate)
    const currentChapter = mainStore.useStore((s) => s.current)
    const lang = mainStore.useStore(s => s.lang)

        
    const chapters = mainStore.useStore(s => s.chapters)
    const chapter = chapters[0]


    // Refs
    const landingRef = useRef()
    const gdbgRef = useRef()

    useEffect(() => {

        gsap.fromTo(landingRef.current.position,
            { y: -2 },
            {
                y: 0,
                duration: 1.5,
                ease: 'inout'
            }
        )

    }, [])

    useFrame(() => {

        if (data.scroll.current <= scrollMap.one && !preventChapterUpdate) {

            if(!currentChapter.dates.includes(1984))
            {
                mainStore.preventChapterUpdate(true)
                mainStore.selectChapter(chapter.name[lang === 'fr' ? lang : 'en'], chapter.dates, chapter.start)
                setTimeout(() => mainStore.preventChapterUpdate(false), 1000)
            }
        }



        gdbgRef.current.scale.y = 4 * Math.min(1, (data.range((scrollMap.one * 0.83), scrollMap.one * 0.97) * 8))

    })

    return <>
        <group position-y={-3.5}>
            <group position={[
                0,
                -2,
                0
            ]} ref={landingRef}>

                <Garage />
            </group>

            {
                __(
                    // FR
                    <group position={[0, 1.2, 0]}>
                        <TextRight
                            maxWidth={1}
                            lineHeight={0.8}
                            fontSize={0.26}
                            positionY={-2.7}
                            fontsOw={fonts.ms.title}
                            fontWeight={'bold'}
                        >
                            1984

                        </TextRight>
                        <TextRight
                            lineHeight={1}
                            fontSize={0.16}
                            positionY={-3}
                            fontsOw={fonts.cm.title}
                        >
                            Création de l’entreprise SILAB

                        </TextRight>
                        <TextRight
                            maxWidth={1.5}
                            lineHeight={1.6}
                            fontSize={0.062}
                            positionY={-3.3}
                            fontsOw={fonts.ms.text}
                        >
                            L’Histoire de SILAB commence dans un atelier rue Charles Brun, à Brive-la-Gaillarde (France).
                        </TextRight>
                        <TextLeft
                            maxWidth={1.7}
                            lineHeight={1.6}
                            fontSize={0.062}
                            positionY={-5.5}
                            fontsOw={fonts.ms.text}
                        >
                            L’entreprise commercialise dans un premier temps un médicament vétérinaire basé sur la valorisation du sang animal.
                        </TextLeft>
                    </group>,

                    //EN
                    <group position={[0, 1.2, 0]}>
                        <TextRight
                            maxWidth={1}
                            lineHeight={0.8}
                            fontSize={0.26}
                            positionY={-2.7}
                            fontsOw={fonts.ms.title}
                            fontWeight={'bold'}
                        >
                            1984

                        </TextRight>
                        <TextRight
                            lineHeight={0.8}
                            fontSize={0.16}
                            positionY={-2.9}
                            fontsOw={fonts.cm.title}
                        >
                            Founding of SILAB

                        </TextRight>
                        <TextRight
                            maxWidth={1.35}
                            lineHeight={1.8}
                            fontSize={0.062}
                            positionY={-3.2}
                            fontsOw={fonts.ms.text}
                        >
                            The story of SILAB begins in a workshop, in Brive-la-Gaillarde (France). 
                        </TextRight>
                        <TextLeft
                            maxWidth={1.7}
                            lineHeight={1.8}
                            fontSize={0.062}
                            positionY={-5.5}
                            fontsOw={fonts.ms.text}
                        >
                            At first, the company markets a veterinary medicinal product based on animal blood.
                        </TextLeft>
                    </group>
                )
            }



            <group position={[0, 1, 0]}>

                {
                    __(
                        // FR
                        <group position={[0, -6.2, 0]}>
                            <TextLeft
                                maxWidth={2}
                                lineHeight={1}
                                fontSize={0.16}
                                font={fonts.cm.title}
                                exposant={'er'}
                                offsetX={1.48}
                            >
                                Commercialisation du 1   actif cosmétique
                            </TextLeft>

                            <TextLeft
                                maxWidth={1.9}
                                lineHeight={1.6}
                                fontSize={0.062}
                                positionY={-0.4}
                                fontsOw={fonts.ms.text}
                            >
                                SILAB propose de l’albumine de sérum bovin, une protéine reconnue pour ses effets liftant et tenseur. 
                            </TextLeft>
                        </group>,
                        // EN
                        <group position={[0, -6.2, 0]}>
                            <TextLeft
                                maxWidth={2}
                                lineHeight={1}
                                fontSize={0.16}
                                font={fonts.cm.title}
                                exposant={'st'}
                                offsetX={0.95}
                            >
                                Launch of the 1  cosmetic active ingredient
                            </TextLeft>

                            <TextLeft
                                maxWidth={1.6}
                                lineHeight={1.8}
                                fontSize={0.057}
                                positionY={-0.4}
                                fontsOw={fonts.ms.text}
                            >
                                SILAB offers a bovine serum albumin, a protein renowned for its lifting and tensors effects. 
                            </TextLeft>
                        </group>)
                }


                <Suspense>
                    <BloodcellIsland />
                </Suspense>

                <JeanPaufique position={[0, -2, 0]} />

                {
                    __(
                        // FR
                        <group position={[0, -7.6, 0]}>
                            <TextLeft
                                maxWidth={2}
                                lineHeight={1}
                                fontSize={0.15}
                                font={fonts.cm.title}
                            >
                                Jean PAUFIQUE, Fondateur
                            </TextLeft>

                            <TextLeft
                                maxWidth={1.6}
                                lineHeight={1.6}
                                fontSize={0.062}
                                positionY={-0.23}
                                fontsOw={fonts.ms.text}
                                textAlign="left"
                            >
                                s’entoure d’une petite équipe, passionnée, portée par un fort esprit d’innovation.
                            </TextLeft>
                        </group>,
                        // EN
                        <group position={[0, -7.6, 0]}>
                            <TextLeft
                                maxWidth={2}
                                lineHeight={0.8}
                                fontSize={0.15}
                                font={fonts.cm.title}
                            >
                                Jean Paufique, Founder
                            </TextLeft>

                            <TextLeft
                                maxWidth={1.6}
                                lineHeight={1.6}
                                fontSize={0.062}
                                positionY={-0.2}
                                fontsOw={fonts.ms.text}
                                textAlign="left"
                            >
                                surrounds himself by a small, passionate team driven by a strong spirit of innovation.
                            </TextLeft>
                        </group>
                    )
                }
                {
                    __(
                        // FR
                        <group position={[0, -10.5, 0]}>
                            <Microscope />
                            <TextRight
                                maxWidth={1}
                                lineHeight={0.8}
                                fontSize={0.26}
                                fontsOw={fonts.ms.title}
                            >
                                1989
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                lineHeight={0.8}
                                fontSize={0.16}
                                positionY={-0.3}
                            >
                                Laboratoire de culture cellulaire
                            </TextRight>
                            <TextRight
                                maxWidth={1.7}
                                lineHeight={1.6}
                                fontSize={0.062}
                                positionY={-0.88}
                                fontsOw={fonts.ms.text}


                            >
                                Le projet de création du laboratoire de culture cellulaire est initié. L’objectif est de comprendre et démontrer les mécanismes d’action des actifs grâce à des outils de biologies cellulaires, par la suite incrémentés par la biologie moléculaire.
                            </TextRight>
                        </group>,
                        // EN
                        <group position={[0, -10.5, 0]}>
                            <Microscope />
                            <TextRight
                                maxWidth={1}
                                lineHeight={0.8}
                                fontSize={0.26}
                                fontsOw={fonts.ms.title}
                            >
                                1989
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                lineHeight={0.8}
                                fontSize={0.16}
                                positionY={-0.3}
                            >
                                Cell culture laboratory
                            </TextRight>
                            <TextRight
                                maxWidth={1.75}
                                lineHeight={1.6}
                                fontSize={0.062}
                                positionY={-0.9}
                                fontsOw={fonts.ms.text}


                            >
                                The project to create a cell culture laboratory is launched. The aim is to understand and demonstrate the active ingredients’ mechanisms of action using cell biology tools, which will subsequently be enhanced by molecular biology.
                            </TextRight>
                        </group>
                    )
                }
                <group position={[0, -9.9, 0]}>

                    {
                        __(
                            // FR
                            <>
                                <TextRight
                                    maxWidth={1.9}
                                    lineHeight={0.8}
                                    fontSize={0.16}
                                    positionY={-1.84}
                                >
                                    Développement européen
                                </TextRight>
                                <TextRight
                                    maxWidth={1.7}
                                    lineHeight={1.6}
                                    fontSize={0.062}
                                    positionY={-2.13}
                                    fontsOw={fonts.ms.text}
                                >
                                    par la mise en place de partenariats avec des distributeurs européens.
                                </TextRight>

                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={1.9}
                                    lineHeight={0.8}
                                    fontSize={0.16}
                                    positionY={-1.84}
                                >
                                    European development
                                </TextRight>
                                <TextRight
                                    maxWidth={1.7}
                                    lineHeight={1.6}
                                    fontSize={0.062}
                                    positionY={-2.0}
                                    fontsOw={fonts.ms.text}
                                >
                                    by setting up partnerships with European distributors.
                                </TextRight>
                            </>
                        )
                    }
                    <Team scale={0.6} position={[width * 0.23 - 1.17, -1.7, 1.9]} >14</Team>
                </group>


                <group position={[0, -11.5, 0]}>

                    <mesh ref={gdbgRef} position={[-2, 0.5, -0.1]} scale={[1.6, 4, 1]}>
                        <planeGeometry args={[1, 1, 32, 32]} />
                        <meshStandardMaterial>
                            <GradientTexture stops={[0, 1]} colors={['#B3D0B8', '#4E9784']} size={100} />
                        </meshStandardMaterial>
                    </mesh>
                </group>



            </group>
        </group>
    </>
}

useFont.preload(import.meta.env.BASE_URL + 'fonts/cormorant/cormorant-v21-latin-regular.woff2')